// AUTO-GENERATED by scripts/generate-blog-data.mjs. Do not edit by hand.
// Re-run with: pnpm --filter @workspace/axle-inc run generate:blog
import type { BlogPostMeta } from "./posts";

export const POSTS_META: BlogPostMeta[] = [
  {
    "slug": "best-trailer-jacks-electric-and-heavy-duty-2026-picks",
    "title": "Best Trailer Jacks: Electric and Heavy-Duty 2026 Picks",
    "category": "Buyer Guides",
    "date": "March 14, 2026",
    "dateIso": "2026-03-14",
    "excerpt": "We see hundreds of trailer jacks come through the shop every year. Here's what we'd put on a trailer in 2026 - and what we'd skip.",
    "readMinutes": 7
  },
  {
    "slug": "dexter-trailer-axle-alternatives-top-2026-options",
    "title": "Dexter Trailer Axle Alternatives: Top 2026 Options",
    "category": "Axles & Suspension",
    "date": "February 22, 2026",
    "dateIso": "2026-02-22",
    "excerpt": "If you're considering an axle other than Dexter, here's what's actually worth your money - and the trade-offs we see come back into the shop.",
    "readMinutes": 8
  },
  {
    "slug": "repacking-wheel-bearings-on-boat-trailers",
    "title": "Repacking Wheel Bearings on Boat Trailers (Without Killing Them)",
    "category": "Service & Repair",
    "date": "January 30, 2026",
    "dateIso": "2026-01-30",
    "excerpt": "Boat-trailer bearings live in water. Here's how to repack them right - and the mistakes we see kill new bearings in a single season.",
    "readMinutes": 9
  },
  {
    "slug": "choosing-the-right-trailer-axle-capacity",
    "title": "Choosing the Right Trailer Axle Capacity (Without Overspending)",
    "category": "Buyer Guides",
    "date": "January 8, 2026",
    "dateIso": "2026-01-08",
    "excerpt": "Bigger isn't always better. Here's how we spec axle capacity for customers - and the math that matters.",
    "readMinutes": 6
  },
  {
    "slug": "electric-vs-hydraulic-trailer-brakes",
    "title": "Electric vs. Hydraulic Trailer Brakes: Which Should You Choose?",
    "category": "Buyer Guides",
    "date": "December 10, 2025",
    "dateIso": "2025-12-10",
    "excerpt": "Electric and hydraulic each have their place. Here's how we recommend between them based on the trailer, the tow vehicle, and the use case.",
    "readMinutes": 7
  },
  {
    "slug": "utility-trailer-care-a-practical-owner-s-guide",
    "title": "Utility Trailer Care: Floors, Loading, Gates and Ramps",
    "category": "Service & Repair",
    "date": "April 16, 2021",
    "dateIso": "2021-04-16",
    "excerpt": "Maintain utility trailer decking, balance cargo and tongue weight, inspect gates and ramps, and adapt tie-downs to the materials you haul.",
    "readMinutes": 6
  },
  {
    "slug": "snowmobile-trailer-spring-prep",
    "title": "Snowmobile Trailer Care for Winter and Storage",
    "category": "Service & Repair",
    "date": "April 9, 2021",
    "dateIso": "2021-04-09",
    "excerpt": "Protect a snowmobile trailer from road salt, check cold-weather brakes, secure the load, and prepare tires and bearings for off-season storage.",
    "readMinutes": 4
  },
  {
    "slug": "buying-a-used-trailer-12-point-inspection",
    "title": "Buying a Used Trailer: Inspection and Paperwork Guide",
    "category": "Buyer Guides",
    "date": "April 2, 2021",
    "dateIso": "2021-04-02",
    "excerpt": "Inspect a used trailer's frame, welds, suspension, tires, wiring and lights, then check title and ownership paperwork before agreeing to buy.",
    "readMinutes": 5
  },
  {
    "slug": "diy-trailer-repair-where-the-line-is",
    "title": "DIY Trailer Repair: When to Use a Professional Shop",
    "category": "Buyer Guides",
    "date": "March 26, 2021",
    "dateIso": "2021-03-26",
    "excerpt": "Separate practical owner-level trailer repairs from spindle, hydraulic and structural work that needs shop equipment and professional experience.",
    "readMinutes": 7
  },
  {
    "slug": "5-minute-pre-trip-inspection-that-catches-most-failures",
    "title": "Trailer Pre-Trip Inspection: Wheels, Lights and Load",
    "category": "Service & Repair",
    "date": "March 19, 2021",
    "dateIso": "2021-03-19",
    "excerpt": "Use a trailer walkaround to check lug nuts, tires, lights, latches, hubs and tongue weight before you head onto the road with your load.",
    "readMinutes": 6
  },
  {
    "slug": "winterizing-a-light-duty-trailer-2021-guide",
    "title": "Winterizing a Light-Duty Trailer: Storage Checklist",
    "category": "Service & Repair",
    "date": "March 12, 2021",
    "dateIso": "2021-03-12",
    "excerpt": "Prepare trailer tires, bearings, seals, electrical connections and suspension for winter storage, with practical checks before the off-season.",
    "readMinutes": 4
  },
  {
    "slug": "boat-trailer-maintenance-checklist-spring",
    "title": "Boat Trailer Maintenance: Hubs, Wiring and Annual Service",
    "category": "Service & Repair",
    "date": "March 5, 2021",
    "dateIso": "2021-03-05",
    "excerpt": "Care for boat trailer hubs after immersion, let bearings cool before launching, protect submerged wiring, and plan an annual maintenance visit.",
    "readMinutes": 4
  },
  {
    "slug": "trailer-wiring-4-flat-vs-7-pin-decoded",
    "title": "Trailer Wiring, Connectors and Breakaway Checks",
    "category": "Service & Repair",
    "date": "February 26, 2021",
    "dateIso": "2021-02-26",
    "excerpt": "Trace trailer lighting problems from the ground connection, protect plug contacts, assess LED upgrades, and inspect the breakaway switch.",
    "readMinutes": 5
  },
  {
    "slug": "a-frame-couplers-buying-and-installing",
    "title": "Trailer Coupler Inspection and Replacement",
    "category": "Trailer Parts",
    "date": "February 19, 2021",
    "dateIso": "2021-02-19",
    "excerpt": "Inspect trailer coupler wear, match the hitch ball correctly, check surge-brake actuators, and understand when coupler replacement is needed.",
    "readMinutes": 7
  },
  {
    "slug": "tongue-jack-buying-guide-for-2021",
    "title": "Trailer Tongue Jacks: Capacity, Care and Selection",
    "category": "Trailer Parts",
    "date": "February 12, 2021",
    "dateIso": "2021-02-12",
    "excerpt": "Choose tongue-jack capacity, compare manual and electric operation, and understand maintenance needs and drop-leg versus fixed-jack designs.",
    "readMinutes": 7
  },
  {
    "slug": "st-trailer-tires-buying-guide-for-2021",
    "title": "Trailer Tire Buying and Maintenance Guide",
    "category": "Trailer Parts",
    "date": "February 5, 2021",
    "dateIso": "2021-02-05",
    "excerpt": "Check trailer tire age, choose the correct load range, maintain cold inflation pressure, and plan spare-tire checks and rotation before towing.",
    "readMinutes": 6
  },
  {
    "slug": "trailer-leaf-springs-replacement-and-diagnosis",
    "title": "Trailer Suspension: Leaf Spring Wear and Replacement",
    "category": "Axles & Suspension",
    "date": "January 29, 2021",
    "dateIso": "2021-01-29",
    "excerpt": "Recognize worn hangers, collapsed bushings and broken leaf springs, understand replacement scope, and compare leaf-spring and torsion suspension.",
    "readMinutes": 5
  },
  {
    "slug": "choosing-the-right-trailer-axle-capacity-up-to-10-000-lb",
    "title": "Trailer Axle Capacity: Ratings, Tags and Tandem Axles",
    "category": "Axles & Suspension",
    "date": "January 22, 2021",
    "dateIso": "2021-01-22",
    "excerpt": "Compare light-duty trailer axle ratings up to 10,000 lb, read the specification plate, and understand how trailer use and tandem layouts affect selection.",
    "readMinutes": 4
  },
  {
    "slug": "electric-trailer-brakes-how-they-work-and-why-they-fail",
    "title": "Electric Trailer Brake Diagnosis and Service",
    "category": "Service & Repair",
    "date": "January 15, 2021",
    "dateIso": "2021-01-15",
    "excerpt": "Understand electric trailer brakes, trace common wiring and magnet faults, and learn when replacing the complete brake assembly makes sense.",
    "readMinutes": 6
  },
  {
    "slug": "repacking-trailer-wheel-bearings-a-step-by-step-guide",
    "title": "Trailer Wheel Bearing Inspection and Maintenance",
    "category": "Service & Repair",
    "date": "January 8, 2021",
    "dateIso": "2021-01-08",
    "excerpt": "Learn what damages trailer wheel bearings, how to inspect hubs, what a shop repack includes, and which trailers benefit from annual bearing service.",
    "readMinutes": 6
  }
];
